import Image from "next/image";
import { LOW_BROKERAGE_STATIC_IMG_URL } from "../../constants/dematBanner";
import OpenDematFloatBannerCtaClient from "./OpenDematFloatBannerCtaClient";
import OpenDematFloatBannerDesktopShell from "./OpenDematFloatBannerDesktopShell";
import OpenDematFloatBannerDesktopShellServer from "./OpenDematFloatBannerDesktopShellServer";
import OpenDematFloatBannerVisibilityClient from "./OpenDematFloatBannerVisibilityClient";
import type { OpenDematFlowBannerProps } from "./OpenDematFloatBanner.types";

const OpenDematFloatBanner = (props: OpenDematFlowBannerProps) => {
  const {
    floatingBannerMainText,
    floatingBannerSubText,
    brokerageMainText,
    loadOnPageLoad = false,
    isPdp = false,
  } = props;
  const bannerImageSrc = LOW_BROKERAGE_STATIC_IMG_URL;

  const bannerImageLoading = loadOnPageLoad ? "eager" : "lazy";
  const bannerImageFetchPriority = loadOnPageLoad ? "high" : "auto";

  const desktopBannerContent = (
    <>
      <div className="w-[235px] shrink-0 bg-[#eff2ff]">
        <img
          src={bannerImageSrc}
          alt="Low brokerage by Bajaj Broking"
          width={235}
          height={73}
          sizes="235px"
          loading={bannerImageLoading}
          fetchPriority={bannerImageFetchPriority}
          className="h-full w-full object-cover"
          draggable={false}
        />
      </div>
      <div className="flex flex-shrink flex-grow items-center justify-between bg-white px-6 py-4">
        <div className="text-container fw-500">
          <div className="text-base font-[500] text-black">
            {floatingBannerMainText ??
              "Start your trading journey with Bajaj Broking"}
          </div>
          <div className="text-xs font-[500] text-gray-600">
            {floatingBannerSubText ??
              "Trade easily in stocks, futures & options and IPOs"}
          </div>
        </div>

        <OpenDematFloatBannerCtaClient
          {...props}
          showCtaPadding={props.showCtaPadding ?? true}
        />
      </div>
    </>
  );

  const mobileFloatingCta = (
    <div className="z-9 fixed bottom-[80px] right-[20px] block md:hidden">
      <OpenDematFloatBannerCtaClient
        {...props}
        isFloating={true}
        showCtaPadding={false}
      />
    </div>
  );

  return (
    <OpenDematFloatBannerVisibilityClient
      floatingBannerMainText={floatingBannerMainText}
      brokerageMainText={brokerageMainText}
      loadOnPageLoad={loadOnPageLoad}
      isPdp={isPdp}
    >
      {loadOnPageLoad ? (
        <OpenDematFloatBannerDesktopShellServer>
          {desktopBannerContent}
        </OpenDematFloatBannerDesktopShellServer>
      ) : (
        <OpenDematFloatBannerDesktopShell isPdp={isPdp}>
          {desktopBannerContent}
        </OpenDematFloatBannerDesktopShell>
      )}

      {mobileFloatingCta}
    </OpenDematFloatBannerVisibilityClient>
  );
};

export default OpenDematFloatBanner;
